import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import EditThirdStepNursery from "src/components/panel/applications_nursery/application_third_step/EditThirdStep";
import * as AppConfig from "../../../../helpers/AppConfig";

const EditThirdStepNurseryView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("applications_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("applications_title")} />
        <EditThirdStepNursery />
      </Sidebar>
    </>
  );
};

export default EditThirdStepNurseryView;
